"use client";

import { useState } from "react";
import { ChevronDown } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import BottomCta from "@/components/BottomCta";

import BenefitsSection from "@/components/Mainland/BenefitsSection";
import MainlandSteps from "@/components/Mainland/MainlandSteps";
import MainlandHero from "@/components/Mainland/MianlandHero";

export default function MainlandPage() {
  const [open, setOpen] = useState(null);

  const FAQS = [
  {
    question: "Why choose a Mainland Company setup?",
    answer:
      "Mainland companies offer greater flexibility, allowing businesses to operate across the UAE, bid for government contracts, and expand without geographical restrictions.",
  },
  {
    question: "Can I own my Mainland business entirely as a foreign investor?",
    answer:
      "Yes. Most commercial and professional activities now permit full foreign ownership under UAE regulations.",
  },
  {
    question: "How quickly can my Mainland company be established?",
    answer:
      "Depending on the business activity and approvals required, company formation can often be completed within a few business days.",
  },
  {
    question: "What business activities can be registered under a Mainland license?",
    answer:
      "A wide range of commercial, industrial, professional, and consultancy activities can be registered, subject to regulatory approval.",
  },
  {
    question: "Do you provide post-incorporation support?",
    answer:
      "Yes. We assist with visas, corporate banking, office solutions, license renewals, compliance requirements, and ongoing business support services.",
  },
];

  return (
    <main className="min-h-screen bg-[#FAFAFA]">
      <Navbar />
      <MainlandHero />

      <BenefitsSection />

      <MainlandSteps />

      <section className="py-14 sm:py-20 lg:py-14 px-4 sm:px-6 lg:px-10 bg-[#FAFAFA]">
        <div className="max-w-full mx-auto">
          <div className="text-left md:text-center mb-12">
            <p className="text-xs sm:text-sm font-bold text-[#B8893A] uppercase tracking-widest mb-3">
              Frequently Asked Questions
            </p>

            <h2
              className="font-bold text-[#000000]"
              style={{
                fontSize: "clamp(28px, 5vw, 48px)",
                lineHeight: "1.3",
              }}
            >
              Everything You Need to Know
            </h2>
          </div>

          <div className="space-y-4">
            {FAQS.map((faq, index) => (
              <div
                key={index}
                className="border border-[#e7e7e7] rounded-2xl overflow-hidden bg-white"
              >
                <button
                  onClick={() => setOpen(open === index ? null : index)}
                  className="w-full flex items-center justify-between p-5 text-left"
                >
                  <span className="font-semibold text-black text-base md:text-lg">
                    {faq.question}
                  </span>

                  <ChevronDown
                    className={`transition-transform duration-300 ${
                      open === index ? "rotate-180" : ""
                    }`}
                  />
                </button>

                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    open === index ? "max-h-40 opacity-100" : "max-h-0 opacity-0"
                  }`}
                >
                  <div className="px-5 pb-5 text-gray-500 leading-relaxed">
                    {faq.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <BottomCta
        title="Ready to Set Up on the Mainland?"
        subtitle="Full UAE market access with transparent pricing and end-to-end support."
      />
      <Footer />
    </main>
  );
}
